module.exports = __webpack_public_path__ + "img/temperature-snow.ecb5646b.svg";